import { getValueAtPath, renderVehicleName } from 'helpers/utils'

export const mapUserSubscriptions = (response) => {
  return response.items.map((item) => {
    const vehicle = getValueAtPath(item, 'subscriptionVehicle.vehicle', {})

    return {
      subscriptionId: item.id,
      subscriptionRef: item.referenceSubscription,
      dtBegin: item.dtBeginPeriod,
      dtEnd: item.dtEndPeriod,
      status: item.status,
      odooId: item.subscriptionOdooId,
      timezone: item.timezone,
      vehicle: {
        name: vehicle.nameVehicle,
        registrationNumber: vehicle.registrationNumber,
        serialNumber: vehicle.serialNumber,
        model: getValueAtPath(vehicle, 'vehicleModel.nameVehicleModel', ''),
        brand: getValueAtPath(vehicle, 'brand.name', ''),
        status: getValueAtPath(item, 'subscriptionVehicle.status', ''),
        vehicleName: renderVehicleName(vehicle),
        odooId: vehicle.odooVehicleId,
        type: vehicle.vehicleType
      }
    }
  })
}
